

import { Messages } from '~src/codegen/Localize';
import { openReactConfirmationDialog } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { ToasterService,ToastType } from '~src/commonInfra/services/ToasterService';

import { IApproveClusterNodeResult } from '../../serverApi/requests/ApproveClusterNodeRequest';
import { BaasEdgePool } from '../../serverApi/resources/BaasEdgePool';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';
import { AcceptPoolNodeButtonProps } from './AcceptPoolNodeButton';


export function openAcceptPoolNodeDialog(props: AcceptPoolNodeButtonProps) {
    const { node, clusterId, siteId, refreshBaasEdgePools } = props;
    const dialogInstance = openReactConfirmationDialog({
      title: Messages.dataConnectSiteSettingsAcceptPoolNodeButton(),
      message: Messages.dataConnectSiteSettingsAcceptPoolNodeDescription({ NAME: L10n.elideIfLong(node.nodeName) }),
      paramsForAction: { nodeId: node.nodeId},
      actionName: Messages.confirm(),
      action: () => {
        return  BaasEdgePool.approveClusterNode({siteId: siteId, clusterId: clusterId, nodeId: node.nodeId})
        .then((result: IApproveClusterNodeResult) => {
          props.refreshBaasEdgePools();
          if (result.success) {
            ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsAcceptPoolNodeSuccess() });
          }
          if (result.errors) {
            ToasterService.instance.pop({
              type: ToastType.Error,
              text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
            });
          }
          return Promise.resolve();
        });
      },
      isActionDelete: false,
      dialogWidth: TabDialogWidth.width375px
    });

    return Promise.resolve(dialogInstance.result);
  }
